import { inject, Injectable } from '@angular/core';

import { Title } from '@angular/platform-browser';
import { GetCurrentClientDataDto } from '../../api/models';
import { AppStateService } from '../app-state.service';
import { AppConfigService } from '../config.service';

@Injectable({
  providedIn: 'root',
})
export class ClientDataInitializerService {
  //#properties
  private currentClientData: any | null = {};
  pathname: string;
  ignorePathNames: string[] = ['/plan/', '/account/'];
  canGetCurrentClientData: boolean = false;
  appConfigService = inject(AppConfigService);
  //#endregion

  constructor(
    private titleService: Title // private route: ActivatedRoute
  ) {
    // toye safheye landing page request nade
    const pathName = window.location.pathname;
    if (pathName) this.canGetCurrentClientData = true;
    else
      this.ignorePathNames.forEach((path) => {
        if (!this.canGetCurrentClientData)
          this.canGetCurrentClientData =
            window.location.pathname.includes(path);
      });
  }

  get getCurrentClientData(): GetCurrentClientDataDto {
    return this.currentClientData;
  }

  init(): Promise<Boolean> {
    return new Promise<Boolean>((resolve) => {
      if (!this.canGetCurrentClientData) {
        resolve(true);
        return;
      }
      const clientData = this.appConfigService.clientData();
      if (clientData) {
        this.currentClientData = clientData;
        this.titleService.setTitle(clientData?.name);
        const favicon = document.getElementById('favicon');
        AppStateService.appTheme = this.currentClientData.desktop;
        AppStateService.primaryColor = this.currentClientData?.primaryColor;
        AppStateService.secondaryColor = this.currentClientData?.secondaryColor;
        AppStateService.loginPageMode = this.currentClientData?.loginPageMode;
        AppStateService.header = this.currentClientData?.header;
        AppStateService.eNamad = this.currentClientData?.eNamad;
        AppStateService.backgroundImagePath =
          this.currentClientData?.backgroundImagePath;
        AppStateService.sliderPicturePaths =
          this.currentClientData?.sliderPicturePaths;
        AppStateService.dashboardMode = this.currentClientData?.dashboardMode;
        if (clientData?.agentLogo)
          (favicon as HTMLLinkElement).href = clientData?.agentLogo;
      }
      resolve(true);
    });
  }
}
